export default __webpack_public_path__ + "static/media/avatarplaceholder.b0a0e43c.jpg";